import React, { useMemo } from 'react'
import Select from 'react-select'
import { groupBy } from 'core/helpers/functional'
import { getStateFullName } from 'core/constants'
import { classNames } from 'core/helpers/misc'

export const CitySelect = ({
	global: { cities, loading },
	clearable,
	city,
	styles,
	meta = {},
	onChange,
}) => {
	const groupedCities = useMemo(
		() =>
			Array.from(groupBy(cities, c => c.state)).map(([uf, items]) => ({
				label: getStateFullName(uf.toString()),
				options: items.map(c => ({
					label: c.fullName,
					value: c.id,
				})),
			})),
		[cities],
	)
	const hasError = meta.touched && !!meta.error

	return (
		<div
			className={classNames({
				'is-invalid': hasError,
			})}
		>
			<Select
				classNamePrefix="react-select"
				isClearable={clearable}
				isDisabled={loading}
				isLoading={loading}
				loadingMessage={() => 'Carregando...'}
				noOptionsMessage={e => `Nenhuma cidade encontrada por '${e.inputValue}'.`}
				onChange={ent => onChange(ent ? cities.find(c => c.id === ent.value) : null)}
				options={groupedCities}
				placeholder="Selecione uma cidade..."
				styles={styles}
				value={city ? { label: city.fullName, value: city.id } : null}
			/>

			{hasError && <div className="form-text text-danger">{meta.error}</div>}
		</div>
	)
}
